// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3cfaB_6Yn6eSpl_C8BsE69{margin:1rem 0 0}._2FW5n0zNov0BKrm9dRm08v{cursor:pointer;display:flex;justify-content:center}._2FW5n0zNov0BKrm9dRm08v span{margin:auto .5rem auto 0}._2FW5n0zNov0BKrm9dRm08v span:before{font-size:20px;top:2px}._33ZJ4vantBPlIFPyCF4AG{width:100%;margin:auto;padding:0 1rem}@media(min-width: 768px){._33ZJ4vantBPlIFPyCF4AG{width:50%}}._3297erQlPlJU-oXv4L22bc{display:flex;flex-direction:column}._3297erQlPlJU-oXv4L22bc label{color:#000;font-weight:bold}._3297erQlPlJU-oXv4L22bc>div{display:flex}._3297erQlPlJU-oXv4L22bc button{width:48px;margin-left:.5rem}._3297erQlPlJU-oXv4L22bc button span{font-size:26px}._3Un6s3v-aJQmdzGGp6OuL1 input{background-color:#ffdedd !important}", ""]);
// Exports
exports.locals = {
	"offerCode_container": "_3cfaB_6Yn6eSpl_C8BsE69",
	"offerCode_text": "_2FW5n0zNov0BKrm9dRm08v",
	"offerCode_form": "_33ZJ4vantBPlIFPyCF4AG",
	"offerCode_input": "_3297erQlPlJU-oXv4L22bc",
	"offerCode_input--error": "_3Un6s3v-aJQmdzGGp6OuL1"
};
module.exports = exports;
